module.exports = __webpack_public_path__ + "img/sanfei_bg_noguarantee.765e1741.png";